import { SigningControlJournalParams } from "@interfaces/signing-control";
import { signingControlService } from "@services/signing-control.service";
import { useMutation } from "react-query";

export const useDownloadSigningControlJournalMutation = () => {
  return useMutation((params: SigningControlJournalParams) =>
    signingControlService.downloadJournal(params)
  );
};
